export const numbers = {
    "z": 
        {
            "NorthEast": 11,
            "SouthEast": 10,
            "SouthWest": 9,
            "NorthWest": 8,
        },
    "x": 
        {
            "NorthEast": 3,
            "SouthEast": 2,
            "SouthWest": 1,
            "NorthWest": 0,
        },
    "y": 
        {
            "NorthEast": 6,
            "SouthEast": 5,
            "SouthWest": 4,
            "NorthWest": 7,
        },
}